import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdDeleteOutline, MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EventEmitter from '../../utils/eventEmitter';
import useAttributeAPI from '../apis/attributeAPI';
import { RxUpdate } from 'react-icons/rx';




const AttributeChanges = () => {
  const attribute = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(attribute.name ? attribute.name : '');
  const { create, update } = useAttributeAPI();
  const [attrValues, setAttrValues] = useState(attribute.attrValues ? attribute.attrValues : [{name: '', value: ''}])


  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['attrValues'] = attrValues;
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['attrValues'] = attrValues;
    data['id'] = attribute.id;
    update(attribute.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };

  useEffect(() => {
    EventEmitter.subscribe('attribute_created', data => {
      navigate('/purchase/attributes/'+data);
    });

    EventEmitter.subscribe('attribute_update', data => {
      navigate('/purchase/attributes/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('attribute_created');
      EventEmitter.unsubscribe('attribute_update');
    }
  },[])


  const addLine = () => {
    setAttrValues((prevState) => [
      ...prevState,
      {
        key: prevState.length,
        name: '',
        value: ''
      }
    ]);
  }
  
  const removeAttr = (key_) => {
    let values = attrValues.filter((value) => value.key !== key_)
    values.map((valueObj, index) => (valueObj['key'] = index))
    setAttrValues(values);
  }

  const handleAttrNameChange = (e, index) => {
    const attrValues_ = [...attrValues]
    attrValues_[index]['key'] = index
    attrValues_[index]['name'] = e.target.value
    setAttrValues(attrValues_);
  }

  const handleAttrValueChange = (e, index) => {
    const attrValues_ = [...attrValues]
    attrValues_[index]['key'] = index
    attrValues_[index]['value'] = e.target.value
    setAttrValues(attrValues_);
  }

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/purchase/attributes'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Attributes</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ attribute.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {attribute.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='routechanges'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Attribute Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 4 }}
          labelWrap={true}
          initialValues={attribute.seo ? attribute : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item label='Display Type' name='display_type' className='font-semibold text-gray-800 mb-4 column' required >
            <Radio.Group className='flex flex-column'>
              <Space direction='vertical'>
                <Radio value={'radio'} className='font-normal'>Radio</Radio>
                <Radio value={'pills'} className='font-normal'>Pills</Radio>
                <Radio value={'select'} className='font-normal'>Select</Radio>
                <Radio value={'color'} className='font-normal'>Color</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item label='Variants Creation Mode' name='variant_creation_mode' className='font-semibold text-gray-800 mb-4' required >
            <Radio.Group className='flex flex-column'>
              <Space direction='vertical'>
                <Radio value={'instantly'} className='font-normal'>Instantly</Radio>
                <Radio value={'dynamically'} className='font-normal'>Dynamically</Radio>
                <Radio value={'never'} className='font-normal'>Never (option)</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item label='E-Commerce Filter Visibility' name='ecommerce_filter_visibility' className='font-semibold text-gray-800 mb-4' required >
            <Radio.Group className='flex flex-column'>
              <Space direction='vertical'>
                <Radio value={true} className='font-normal'>Visible</Radio>
                <Radio value={false} className='font-normal'>Hidden</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Tabs 
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'Attribute Values',
                children: 
                  <table className='w-full'>
                    <thead>
                      <tr className='flex justify-between text-left'>
                        <th className='w-1/2'>Name</th>
                        <th className='w-1/2'>Value</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody style={{maxHeight: '100px', overflow: 'scroll'}}>
                      {attrValues.map((attrValue, id) => 
                        <tr key={id} className='flex justify-between items-center border-b-2'>
                          <td className='w-1/2'><Input value={attrValue.name} onChange={e=>handleAttrNameChange(e, id)} className='w-1/2 border-x-0 border-t-0 input-outline-none font-normal ' style={{paddingTop: '4px', paddingBottom: '4px'}}/></td>
                          <td className='w-1/2'><Input value={attrValue.value} onChange={e=>handleAttrValueChange(e, id)} className='w-1/2 border-x-0 border-t-0 input-outline-none font-normal ' style={{paddingTop: '4px', paddingBottom: '4px'}}/></td>
                          <td>{attrValues.length > 1 && <MdDeleteOutline size={'1rem'} onClick={()=>removeAttr(id)} color='red' className='hover:cursor-pointer'/>}</td>
                        </tr>
                      )}
                    </tbody>
                    <Button className='mt-3 border-0' onClick={addLine}>Add Line</Button>
                  </table>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default AttributeChanges;